import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-275a7516"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-container"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = {
  key: 0,
  class: "verification-inputs"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "sign-in" }, null, -1))

import PartialInputsContainer from "@/components/forms/PartialInputsContainer/PartialInputsContainer.vue";
import CountryCodeSelect from "@/components/forms/CountryCodeSelect/CountryCodeSelect.vue";
import Form from "@/components/layouts/Form.vue";
import GenericButton from "@/components/buttons/GenericButton.vue";
import { useComputedValue } from "@/composables";
import { getIsAuthenticated } from "@/services/maitrejaApi";
import { GetterTypes } from "@/store";
import { Profile } from "@/store/auth/state";
import { IConnectPhoneData } from "@/types/auth";
import {
  FormFieldType,
  FormFieldNameEnum,
  LoginPhoneFormDataObjectType,
  FormFieldDataObject,
} from "@/types/form";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { IPartialInputEmitType } from "../PartialInput";
import { GenericButtonVariantEnum } from "@/types/button";
import Input from "../Input.vue";

interface PhoneVerificationFormEmits {
  (e: "togglePopup", arg: boolean): void;
}

interface Props {
  data: IConnectPhoneData & FormFieldDataObject<LoginPhoneFormDataObjectType>;
  handleUpdateCountryCode: (countryCode: string) => void;
  handleStartVerification: () => Promise<void>;
  handleConfirmCode: () => Promise<void>;
  updatePartialInput: (eventObject: IPartialInputEmitType) => void;
  handlePasteToPartialInputs: (e: ClipboardEvent) => void;
  updatePhoneNumber: (e: any) => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneVerificationForm',
  props: {
    data: {},
    handleUpdateCountryCode: { type: Function },
    handleStartVerification: { type: Function },
    handleConfirmCode: { type: Function },
    updatePartialInput: { type: Function },
    handlePasteToPartialInputs: { type: Function },
    updatePhoneNumber: { type: Function }
  },
  emits: ["togglePopup"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n();
const isAuthenticated = getIsAuthenticated();
const profile = useComputedValue<Profile>(GetterTypes.GET_AUTH_PROFILE);
const hasPhoneNumber = computed<boolean>(() => {
  return Boolean(profile?.value.countryCode && profile?.value.phoneNumber);
});

const appliedTexts = computed(() => {
  let title = "auth.login";
  let text = "welcome.loginWithPhoneCode";
  let verifyButtonText = "auth.buttons.sendVerificationSms";
  let confirmButtonText = "auth.buttons.login";

  if (isAuthenticated && hasPhoneNumber) {
    verifyButtonText =
      "settings.connectPhoneNumberContent.connectNewPhoneNumber";
  }
  if (props.data.isVerificationStarted) {
    text = "welcome.confirmLoginWithPhoneCode";
  }
  if (isAuthenticated && props.data.isVerificationStarted) {
    title = "settings.connectPhoneNumberContent.confirmation.title";
    text = "settings.connectPhoneNumberContent.confirmation.text";
    confirmButtonText = "settings.connectPhoneNumberContent.savePhoneNumber";
  }

  return {
    title: t(title),
    text: t(text),
    verifyButtonText,
    confirmButtonText,
  };
});

const handleTogglePopup = (isPopupOpen: boolean) => {
  emit("togglePopup", isPopupOpen);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["verification-form", {
      'verification-started': _ctx.data.isVerificationStarted,
      'is-authenticated': _unref(isAuthenticated),
    }])
    }, [
      (!_unref(isAuthenticated) || _ctx.data.isVerificationStarted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(appliedTexts.value.title), 1),
            _createElementVNode("p", _hoisted_3, _toDisplayString(appliedTexts.value.text), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(Form, null, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["verification-form-content", { 'verification-started': _ctx.data.isVerificationStarted }])
          }, [
            (!_ctx.data.isVerificationStarted)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(CountryCodeSelect, {
                    onUpdateCountryCode: _ctx.handleUpdateCountryCode,
                    onTogglePopup: handleTogglePopup
                  }, null, 8, ["onUpdateCountryCode"]),
                  _createVNode(Input, {
                    "model-value": _ctx.data.phoneNumber,
                    name: _unref(FormFieldNameEnum).PhoneNumber,
                    pattern: "[0-9]{9}",
                    placeholder: "123 456 789",
                    type: _unref(FormFieldType).Tel,
                    required: "",
                    errors: _ctx.data.errors,
                    "is-checked": hasPhoneNumber.value,
                    "onUpdate:modelValue": _ctx.updatePhoneNumber
                  }, null, 8, ["model-value", "name", "type", "errors", "is-checked", "onUpdate:modelValue"])
                ]))
              : (_openBlock(), _createBlock(PartialInputsContainer, {
                  key: 1,
                  "strings-array": _ctx.data.codesArray,
                  onUpdatePartialInputsContainer: _ctx.updatePartialInput,
                  onPasteToPartialInputs: _ctx.handlePasteToPartialInputs
                }, null, 8, ["strings-array", "onUpdatePartialInputsContainer", "onPasteToPartialInputs"])),
            _withDirectives(_createVNode(GenericButton, {
              id: "sign-in-button",
              variant: _unref(GenericButtonVariantEnum).Primary,
              text: appliedTexts.value.verifyButtonText,
              "is-loading": _ctx.data.isLoading,
              onClick: _ctx.handleStartVerification
            }, null, 8, ["variant", "text", "is-loading", "onClick"]), [
              [_vShow, !_ctx.data.isVerificationStarted]
            ]),
            (_ctx.data.isVerificationStarted)
              ? (_openBlock(), _createBlock(GenericButton, {
                  key: 2,
                  variant: _unref(GenericButtonVariantEnum).Primary,
                  text: appliedTexts.value.confirmButtonText,
                  "is-loading": _ctx.data.isLoading,
                  onClick: _ctx.handleConfirmCode
                }, null, 8, ["variant", "text", "is-loading", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.data.isVerificationStarted)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 3,
                  class: "resend-code",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleStartVerification && _ctx.handleStartVerification(...args)))
                }, _toDisplayString(_unref(t)("auth.buttons.resendVerificationSms")), 1))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      })
    ], 2),
    _hoisted_5
  ], 64))
}
}

})